import { createSlice } from "@reduxjs/toolkit";
import { getGlobalMetaData } from "../ReduxActions/getGlobalData";

const initialState = {
  data: null,
  loading: false,
  error: null
};

const WebsiteGlobalData = createSlice({
  name: "WebsiteGlobalData",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {

    builder
      .addCase(getGlobalMetaData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGlobalMetaData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getGlobalMetaData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load org data";
      });
  },
});

export default WebsiteGlobalData.reducer;
